// biome-ignore-all lint/suspicious/noConsole: Overwriting console methods
export const trace = !import.meta.env.PROD ? (...args) => console.log('[src/index]', ...args) : () => {};
